import React from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const CHART_MARGIN = { top: 6, right: 10, bottom: 0, left: -16 };
const LINE_GREEN = "#B8E986";
const LINE_BLUE = "#AEDFF7";

function CustomTooltip({
  active,
  payload,
  label,
  unitLabel = "Wert",
  currentLabel = "Aktueller Zeitraum",
  previousLabel = "Vergleichszeitraum",
}) {
  if (!active || !payload?.length) return null;

  const currentValue = payload.find((item) => item.dataKey === "value");
  const previousValue = payload.find((item) => item.dataKey === "value2");

  return (
    <div className="ac-dash-tooltip">
      <div className="ac-dash-tooltip-label">
        {label} · {currentLabel}
      </div>

      <div className="ac-dash-tooltip-list">
        {currentValue && (
          <div className="ac-dash-tooltip-row">
            <span>{unitLabel}</span>
            <strong>{currentValue.value}</strong>
          </div>
        )}

        {previousValue && (
          <div className="ac-dash-tooltip-row">
            <span>{previousLabel}</span>
            <strong>{previousValue.value}</strong>
          </div>
        )}
      </div>
    </div>
  );
}

export default function UsageLineChart({
  data = [],
  unitLabel = "Wert",
  currentLabel = "Aktueller Zeitraum",
  previousLabel = "Vergleichszeitraum",
}) {
  return (
    <div className="ac-dash-chartcard">
      <div className="ac-dash-chartbox">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={CHART_MARGIN}>
            {/* Gitter und Achsen */}
            <CartesianGrid
              stroke="var(--ac-chart-grid)"
              strokeDasharray="4 6"
            />

            <XAxis
              dataKey="label"
              tick={{ fill: "var(--ac-chart-axis)", fontSize: 11 }}
              axisLine={false}
              tickLine={false}
            />

            <YAxis
              tick={{ fill: "var(--ac-chart-axis)", fontSize: 11 }}
              axisLine={false}
              tickLine={false}
            />

            {/* Tooltip */}
            <Tooltip
              cursor={{
                stroke: "var(--ac-chart-cursor)",
                strokeWidth: 1,
                strokeDasharray: "4 6",
              }}
              content={
                <CustomTooltip
                  unitLabel={unitLabel}
                  currentLabel={currentLabel}
                  previousLabel={previousLabel}
                />
              }
            />

            {/* Linien */}
            <Line
              type="monotone"
              dataKey="value"
              stroke={LINE_GREEN}
              strokeWidth={3}
              dot={{
                r: 3.5,
                stroke: LINE_GREEN,
                strokeWidth: 2,
                fill: "var(--ac-chart-dot-fill)",
              }}
              activeDot={{
                r: 5,
                stroke: LINE_GREEN,
                strokeWidth: 2,
                fill: "var(--ac-chart-dot-fill)",
              }}
              animationDuration={800}
              animationEasing="ease-out"
            />

            <Line
              type="monotone"
              dataKey="value2"
              stroke={LINE_BLUE}
              strokeWidth={2.2}
              dot={false}
              animationDuration={850}
              animationEasing="ease-out"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}